import styled from 'styled-components';

export const DisabledDiv = styled.div`
    pointer-events: ${props => (props.disablePointer ? 'none' : null)};
    opacity: ${props => (props.disablePointer ? 0.2 : null)};
`;

export const HiddenDiv = styled.div`
    height: ${props => (props.hide ? 0 : 'auto')};
    display: ${props => (props.hide ? 'none' : 'block')};
    transition: all ${props => (props.hide ? 0 : 0.3)}s ease-in;
    padding-bottom: 10px;
`;

export const BorderDiv = styled.div`
    border: solid 1px ${props => (props.hide ? '#fff' : props.theme.colors.darkgray)};
    background-color: ${props => (props.hide ? '#fff' : '#FAFAFA')};
    transition: all ${props => (props.hide ? 0 : 0.4)}s ease-in;
    padding: 5px 10px 0px;
    margin-bottom: 10px;
`;

export const HiddenBorderDiv = styled.div`
    border: solid 1px ${props => (props.hide ? '#fff' : props.theme.colors.darkgray)};
    background-color: ${props => (props.hide ? '#fff' : '#FAFAFA')};
    transition: all 0.4s ease-in;
    padding: ${props => (props.hide ? '' : '5px 10px 0px')};
    margin: 10px 0;
`;

export const NoPointerEventsDiv = styled.div`
    pointer-events: none;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/form/UtilityDivs.js